import styled from 'styled-components/macro';

import { NavLink } from 'react-router-dom';
import ResponsiveContainer from '../ResponsiveContainer';

interface IStyledProps {
  light?: number;
}

const Wrapper = styled(ResponsiveContainer)`
  background: transparent;
`;

const Inner = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
`;

const NavItem = styled(NavLink)<IStyledProps>`
  text-decoration: none;
  color: ${p => p.theme.colors.gray};
  white-space: pre-wrap;

  :last-child {
    color: ${p => (p.light === 1 ? 'white' : p.theme.colors.black)};
  }
`;

const Text = styled.p`
  cursor: pointer;
  color: ${p => p.theme.colors.gray};
  white-space: pre-wrap;
`;

export { Wrapper, Inner, NavItem, Text };
